<template>
  <div class="gui-flex gui-flex-rows">
    <v-dialog
      v-model="dialogRemove"
      persistent
      max-width="700px"
      transition="dialog-transition"
      v-if="dialogRemove"
    >
      <v-card flat class="table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows no__radius">
        <div class="gui-flex gui-flex-rows">

          <v-card color="grey lighten-4" class="pa-3 elevation-0">
            <v-card-title class="headline grey lighten-2">
              Produkt - detail
            </v-card-title>
            <v-card-text>
              <v-card flat class="no__radius table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows">
                <div class="gui-flex gui-flex-rows" v-if="!editMode">
                  <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 pb-1 elevation-0">
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <h2 class="body-3 mb-0 bold">Detail obchodu</h2>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mt-3">
                        <v-flex xs12 sm6 md3>
                          <p class="grey--text caption mb-1">Datum:</p> <strong>lorem</strong>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <p class="grey--text caption mb-1">Klient:</p> <strong>lorem</strong>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 mt-4 pb-1 elevation-0">
                    <v-card-text>
                      <v-layout row wrap class="mt-3">
                        <v-flex xs12 sm6 md3>
                          <p class="grey--text caption mb-1">Produkt:</p> <strong>lorem</strong>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <p class="grey--text caption mb-1">Cena/ks (cena fixace):</p> <strong>lorem</strong>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <p class="grey--text caption mb-1">Počet:</p> <strong>lorem</strong>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <p class="grey--text caption mb-1">Kredity:</p> <strong>lorem</strong>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mt-3">
                        <v-flex xs12 sm6 offset-sm6 md3 offset-md9>
                          <p class="mb-1"><span class="grey--text caption">Celkem kreditů:</span> <strong>9</strong></p>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </div>

                <div class="gui-flex gui-flex-rows" v-else>
                  <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 pb-1 elevation-0">
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <h2 class="body-3 mb-0 bold">Detail obchodu</h2>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mt-3">
                        <v-flex xs12 sm6>
                          <v-text-field label="Datum" class="mx-2"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field label="Klient" class="mx-2"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <v-card color="grey lighten-4" class="pt-3 pl-3 pr-3 mt-4 pb-1 elevation-0">
                    <v-card-text>
                      <v-layout row wrap class="mt-3">
                        <v-flex xs12 sm6>
                          <v-text-field label="Produkt" class="mx-2"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field label="Cena/ks (cena fixace)" class="mx-2"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="mt-3">
                        <v-flex xs12 sm6>
                          <v-text-field label="Počet" class="mx-2"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field label="Kredity" class="mx-2"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </div>
              </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-if="!editMode" @click="editModeClick" class="mt-3 elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
              <v-btn color="primary" v-if="editMode" @click="edit" class="mt-3 elevation-0"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
              <v-btn class="grey elevation-0 lighten-2 mt-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDetail"
      persistent
      max-width="1000px"
      transition="dialog-transition"
      v-if="dialogDetail"
    >
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <ObchodyProvizeDetailContent :id="operace_id"></ObchodyProvizeDetailContent>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="dialogDetail=false">Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="custom-scrollbar">
      <v-card class="pt-3 pl-3 pr-3 pb-0 no__radius transparent">
        <!--<v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h2>Předběžné kredity z&nbsp;nezaplacených objednávek</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-4">
            <v-flex xs4>
              <h3>Celkem: {{data.kredity | formatDouble}} kreditů</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-4">
            <v-layout row wrap class="mt-3">
              <v-flex xs12>
                <div class="no__radius">
                  <v-data-table
                    :headers="headersPredbezne"
                    :items="data.obchody"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.datum | formatDate }}</td>
                      <td>{{ props.item.klient.nazev_osoby }}</td>
                      <td>{{ props.item.podrizeny_spolupracovnik }}</td>
                      <td>{{ props.item.popis }}</td>
                      <td>{{ props.item.celkem | formatDouble }} Kč</td>
                      <td>{{ props.item.kredity | formatDouble }} kr.</td>
                      <td class="text-center">
                        <v-btn color="primary" @click="dialogRemove=true" class="elevation-0"><v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>-->
        <v-card-text>
          <v-layout row wrap class="mt-2">
            <v-flex xs4 sm2>
              <obdobi v-model="obdobi_id" label="Vyberte období"></obdobi>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-3" v-if="info!=null">
            <v-flex xs4>
              <h3 class="mx-2">Období: <span v-html="padMesic(obdobi.mesic, 2)"></span>/<span>{{obdobi.rok}}</span> &nbsp; Stav: nevyřízeno</h3>
            </v-flex>
            <v-flex xs4>
              <h3 class="mx-2">{{info.celkem_kredity | formatDouble}} kreditů</h3>
            </v-flex>
            <v-flex xs4>
              <h3 class="mx-2">Provize: {{info.celkem_castka | formatMoney}} Kč</h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-4" v-if="items!=null">
            <v-flex xs12>
              <div class="no__radius">
                <v-data-table
                  :headers="headers"
                  :items="items"
                  hide-controls
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.datum | formatDate }}</td>
                    <td>
                      <router-link :to="{ name: '/klienti/' + props.item.osoba.id }" target="_blank">
                        {{ props.item.osoba.nazev_osoby }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="{ name: '/klienti/' + props.item.obchodnik.id }" target="_blank">
                        {{ props.item.obchodnik.nazev_osoby }}
                      </router-link>
                    </td>
                    <td>{{ props.item.popis }}</td>
                    <td class="text-xs-right">{{ props.item.platba_castka | formatMoney }} {{props.item.platba_mena.zkratka}}</td>
                    <td class="text-xs-right">{{ props.item.kredity | formatDouble }} kr.</td>
                    <td class="text-xs-right">{{ props.item.pozice_hodnota_kreditu | formatMoney }} Kč</td>
                    <td class="text-xs-right">{{ props.item.castka | formatMoney }} Kč</td>
                    <td class="text-xs-right">
                      <v-btn color="primary" @click="operace_id=props.item.operace_id;dialogDetail=true;" class="elevation-0"><v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import RocniBonusy from '@/pages/Klienti/RocniBonusy'
import ObchodyProvizeDetailContent from '@/pages/Admin/ObchodyProvizeDetailContent'
export default {
  data () {
    return {
      dialogRemove: false,
      loading: false,
      editMode: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Klient', value: 'klient' },
        { text: 'Podřízený spolupracovník', value: 'podrizeny_spolupracovnik' },
        { text: 'Popis', value: 'popis' },
        { text: 'Platba', value: 'castka', align: "right" },
        { text: 'Kredity', value: 'kredity', align: "right" },
        { text: 'Hodnota kreditů', value: 'hodnota_kreditu', align: "right" },
        { text: 'Provize', value: 'provize', align: "right" },
        { text: 'Zobrazit', value: null, sortable: false, align: 'right' }
      ],
      headersPredbezne: [
        { text: 'Datum', value: 'datum' },
        { text: 'Klient', value: 'klient' },
        { text: 'Podřízený spolupracovník', value: 'podrizeny_spolupracovnik' },
        { text: 'Popis', value: 'popis' },
        { text: 'Částka', value: 'castka' },
        { text: 'Kredity', value: 'kredity' }
        //{ text: 'Zobrazit', value: null, sortable: false, align: 'center' }
      ],
      items: null,
      info: null,
      obdobi_id: null,
      obdobi: null,
      dialogDetail: false,
      operace_id: null
    }
  },
  computed: {
    me () {
      return window.ME;
    }
  },
  watch: {
    obdobi_id () {
      this.load();
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  methods: {
    editModeClick () {
      this.editMode = true
    },
    edit () {
      this.editMode = false
    },
    load () {
      window.API.get("osoby/"+this.$props.id+"/obchody-provize/" + this.obdobi_id + "/search").then(function(body) {
        this.info = body.info;
        this.obdobi = body.obdobi;
        this.items = body.polozky;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    padMesic ($v) {
      if ($v == null)
        return "";
      $v = $v.toString();
      while($v.length < 2) {
        $v = "0" + $v;
      }
      return $v;
    }
  },
  props: {
    id: String
  },
  components: {
    RocniBonusy, ObchodyProvizeDetailContent
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/ObchodyProvizeKlient.vue